export enum SkeletonElementSize {
  Default = 'default'
}
